/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : AUTH EXPIRED LINK : STYLES --------------- ++++++++++ */
export default theme =>({
    expiredlink: {
        '& h3':{
            fontSize: pxToEm(32),
            fontWeight: 500,
            marginBottom: pxToEm(12)
        },
        '& .invitationcopy':{
            fontWeight: 500,
            marginBottom: pxToEm(20)
        },
        '& button':{
            width: '100%'
        }
    }
});
